import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService, ModalComponent, NumberInputComponent } from 'common';
import { TranslateModule } from '@ngx-translate/core';
import { provideIcons } from '@ng-icons/core';
import { heroInformationCircleMini } from '@ng-icons/heroicons/mini';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EthUnitUtil } from '@31third/common';
import BigDecimal from 'js-big-decimal';
import {
  RebalancingRepository,
  RebalancingState,
} from '../../../../repository';

@Component({
  selector: 'common-rebalancing-sell-portfolio-percentage-modal',
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    TranslateModule,
    ReactiveFormsModule,
    NumberInputComponent,
    FormsModule,
  ],
  providers: [
    provideIcons({
      heroInformationCircleMini,
    }),
  ],
  templateUrl: './sell-portfolio-percentage-modal.component.html',
  styleUrls: ['./sell-portfolio-percentage-modal.component.scss'],
})
export class SellPortfolioPercentageModalComponent implements OnChanges {
  @Input()
  public isOpen = false;

  @Output()
  public isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public percentage: number | undefined;
  public value: number | undefined = 0;
  public maxValue = 0;

  constructor(
    private readonly rebalancingRepository: RebalancingRepository,
    private readonly alertService: AlertService,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    this.maxValue = this.rebalancingRepository.getPortfolioValue();
  }

  public get store(): RebalancingState {
    return this.rebalancingRepository.store.getValue();
  }

  public handleIsOpenChange(isOpen: boolean): void {
    this.resetModal();
    this.isOpenChange.emit(isOpen);
  }

  private resetModal(): void {
    this.percentage = undefined;
  }

  public onCloseClick(): void {
    this.handleIsOpenChange(false);
  }

  public onPercentageChange(percentage: number): void {
    this.percentage = percentage;
    this.value = this.maxValue * (percentage / 100);
  }

  public onSellPortfolioPercentage(): void {
    if (!this.percentage || this.percentage < 0 || this.percentage > 100) {
      this.alertService.showError('sellPortfolioPercentageModal.error');
      return;
    }

    this.store.sellEntries.forEach(entry => {
      const fullAmount = EthUnitUtil.convertBigIntToBigDecimal(
        entry.asset.balance,
        entry.asset.token.decimals,
      );
      entry.amount = fullAmount
        .multiply(new BigDecimal(this.percentage! / 100))
        .getValue();
    });

    this.alertService.showSuccess('sellPortfolioPercentageModal.success', {
      percentage: this.percentage,
    });
    this.handleIsOpenChange(false);
  }
}
